import { gql } from 'graphql-request';

export const getCustomerOrderListQuery = async (): Promise<string> => {
  const response = await fetch('/schemas/customerOrderList.txt');
  const text = await response.text();

  const query = gql`
    ${text}
  `;

  return query;
};
